export default __webpack_public_path__ + "static/about-2-61d21b3eb2221cd198f72b71efae8668.webp";